define('app/sdc/chain/sdc-chain-factory',[],function () {
	"use strict";
	function sdcChainFactory(fn) {

	}
});
